import EquifaxIcon from "src/assets/EquifaxIcon.svg?react";
import { getDefaultEquifaxCanadaConsumerCreditFile } from "src/connections/connectionConfigs/equifaxCanada/equifaxCanadaResources";
import { EquifaxCanadaTemplate } from "src/connections/connectionConfigs/equifaxCanada/equifaxCanadaTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const EQUIFAX_CANADA_CONFIG: ConnectionConfig<"equifax_canada"> = {
  icon: EquifaxIcon,
  description:
    "Make more accurate credit decisions with robust consumer credit data",
  template: EquifaxCanadaTemplate,
  name: "Canada | Equifax",
  resources: {
    equifax_canada_consumer_credit_file: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/equifax-canada#consumer-credit-file",
      integrationResource: getDefaultEquifaxCanadaConsumerCreditFile,
    },
  },
};
